import React from 'react';
import { useRouter } from 'next/navigation';
import { cn } from '@/utils/cn';
import BackButton from '../Button/BackButton';
import PageTitle from '../Typography/PageTitle';

function TopHeaderTitle({
  onBack,
  title = '',
  iconName = 'angle-down',
  className,
}) {
  const router = useRouter();
  return (
    <section
      className={cn(
        'top-header-title flex lg:hidden flex-row items-center gap-2 py-10 lg:py-8 px-16 !bg-richcarmine w-full h-[40px] lg:h-[36px]',
        className,
      )}
    >
      <div className="relative flex items-center justify-center w-full">
        {iconName.length ? (
          <div className="block lg:hidden absolute top-auto bottom-auto left-0 cursor-pointer">
            <BackButton
              iconName={iconName}
              onBack={() => (onBack !== undefined ? onBack() : router.back())}
            />
          </div>
        ) : null}

        <div className="w-full flex items-center justify-center gap-[5px]">
          <PageTitle
            text={title}
            className="w-full text-center text-white font-medium capitalize"
          />
        </div>
      </div>
    </section>
  );
}

export default TopHeaderTitle;
